import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { ContainerRoute } from "@components/common";
import { OrganizationList } from "@views/organizations/organization-list";

const SingleOrgDashboard = React.lazy(() =>
  import("@views/dashboard/dashboard.single")
);

export default function Organizations({ responsiveStyles = {} }) {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <ContainerRoute
        exact={true}
        path={path}
        component={OrganizationList}
        responsiveStyles={responsiveStyles}
      ></ContainerRoute>

      <Route
        exact={true}
        path={`${path}/:orgCode`}
        component={SingleOrgDashboard}
      ></Route>
    </Switch>
  );
}
